import type {
  AccountsData,
  ProfileItem,
  ProfilesData,
  User,
  UserAccountDetails,
} from "../../store/useAuthStore";

export const INFINITY_LEARN_COOKIE_NAME = "INFINITY_LEARN";
export const ACCOUNTS_OF_LOGGED_IN_USER_COOKIE_NAME = "accountsOfLoggedInUser";
export const PROFILES_OF_LOGGED_IN_USER_COOKIE_NAME = "profilesOfLoggedInUser";

/** IL portal cookie — mirrors profiles API `unified_account_details`. */
export type ProfilesOfLoggedInUserPayload = {
  unified_account_id: string;
  profiles: ProfileItem[];
  user_account_details: UserAccountDetails;
};

export type InfinityLearnUserDto = {
  unified_account_id: string;
  uam_id?: number;
  admission_id?: string;
  crn_id?: string;
  branch_id?: string;
  tenant_id?: string;
  vertical_id?: number;
  is_default_profile?: boolean;
  is_temp_password?: boolean;
  tenant_code?: string;
  exams?: { examId: number; name: string }[];
  studentExams?: { examId: number; name: string }[];
  first_name?: string;
  last_name?: string;
  firstName?: string;
  lastName?: string;
  isd_code?: string;
  isdCode?: string;
  phone?: string;
  email?: string | null;
  profile_photo?: string | null;
  whatsapp_consent?: boolean;
  country?: string | null;
  guardian_name?: string | null;
  guardian_phone?: string | null;
  academic_section?: string | null;
  user_type?: UserAccountDetails["user_type"];
  grade?: UserAccountDetails["grade"];
  studentGrade?: UserAccountDetails["grade"];
  board?: string | null;
  role?: UserAccountDetails["role"];
  campus?: string | null;
  created_at?: string;
  updated_at?: string;
  is_active?: boolean;
  last_logged_in_time?: string;
  is_pass_set?: boolean;
  description?: string | null;
  designation?: string | null;
  gender?: string | null;
  activation_test?: unknown;
  is_walkthrough?: unknown;
  dob?: string | null;
  user_deactivation?: boolean;
  remaining_phone_change_attempts?: number;
  [key: string]: unknown;
};

export type InfinityLearnCookiePayload = {
  accessToken: string;
  login_token?: string;
  userDto: InfinityLearnUserDto;
};

export type AccountsOfLoggedInUserItem = {
  unified_account_id: string;
  first_name: string;
  last_name: string;
  grade: number;
  user_account_photo: string | null;
};

export type MappedHandoffAuth = {
  accessToken: string;
  user: User;
  profilesData: ProfilesData;
  accountsData: AccountsData;
  defaultProfile: ProfileItem;
};
